import Page from './page';
import { RouterConfig } from 'router/AppRoute';
import paths from 'helper/pathRoutes';

const routes: RouterConfig[] = [
  {
    path: paths.vehicle_manager,
    page: Page,
  },
];

export default routes;
